import { replaceDiImpl } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import { BcfActivatedRoute } from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/bcf-activated-route';
import { BcfActivatedUrl } from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/bcf-activated-url';
import { BcfRouterService } from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/bcf-router.service';
import { HistoryState as Bcf2HistoryState } from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/history-state';
import { HistoryUrl as Bcf2HistoryUrl } from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/history-url';
import { provideActivatedRoute } from '@tmf-shared-platform/activated-route/activated-route';
import { provideActivatedUrl } from '@tmf-shared-platform/activated-url/activated-url';
import { provideHistoryState } from '@tmf-shared-platform/history-state/history-state';
import { provideHistoryUrl } from '@tmf-shared-platform/history-url/history-url';
import { BcfActivatedRouteAdapter } from './bcf-activated-route-adapter';
import { BcfActivatedUrlAdapter } from './bcf-activated-url-adapter';
import { HistoryUrlAdapter } from './bcf-history-url-adapter';
import { BcfRouterAdapter } from './bcf-router-adapter';

export function registerBcf2RouterAdapters(): void {
  replaceDiImpl(BcfRouterService, () => new BcfRouterAdapter());
  replaceDiImpl(BcfActivatedUrl, () => new BcfActivatedUrlAdapter(provideActivatedUrl()));
  replaceDiImpl(BcfActivatedRoute, () => new BcfActivatedRouteAdapter(provideActivatedRoute()));
  replaceDiImpl(Bcf2HistoryState, () => provideHistoryState());
  replaceDiImpl(Bcf2HistoryUrl, () => new HistoryUrlAdapter(provideHistoryUrl()));
}
